// extracted by mini-css-extract-plugin
export var items = "PartnersCarousel-module--items--3b447";
export var logoSec = "PartnersCarousel-module--logoSec--1310b";
export var partnerSec = "PartnersCarousel-module--partnerSec--4a036";
export var patnerTitle = "PartnersCarousel-module--patnerTitle--5cf7e";
export var pauseicons = "PartnersCarousel-module--pauseicons--21976";